module.exports = __webpack_public_path__ + "images/for_company_page/media_thebridge_9d800927485b59f2c7790dfbae61a7f4.png";